import AuthDataStore from '../../datastores/AuthDataStore';

export default class AuthDataStoreMock implements AuthDataStore {
  async logIn() {
    return {
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJjNzczNWQzNS0xODczLTViYmQtOTgyOS03N2I3ZDBkZGI2ZmIiLCJyb2xlIjoiU1RVREVOVCIsInByb3ZpZGVyIjoiQ1VTVE9NIiwiZXhwIjoxNjIzMjc4MzY1fQ.Si2E9fSSjsFqk3eZC4kE6Q64ZyXK0QZIJIMKsCg_0hvevVdLxnjgyZxV5nWRu_DNOQ_vcJCjdAAThW5F3Fw-BQ',
      refreshToken: 'bu3bnoveJBGlVxqeiL7POvuMrEAYXemc5LRNO8Fq5TsJMPFa/EOciQ=='
    };
  }

  async refreshToken() {
    return {
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJjNzczNWQzNS0xODczLTViYmQtOTgyOS03N2I3ZDBkZGI2ZmIiLCJyb2xlIjoiU1RVREVOVCIsInByb3ZpZGVyIjoiQ1VTVE9NIiwiZXhwIjoxNjIzMjc4MzY1fQ.Si2E9fSSjsFqk3eZC4kE6Q64ZyXK0QZIJIMKsCg_0hvevVdLxnjgyZxV5nWRu_DNOQ_vcJCjdAAThW5F3Fw-BQ',
      refreshToken: 'bu3bnoveJBGlVxqeiL7POvuMrEAYXemc5LRNO8Fq5TsJMPFa/EOciQ=='
    };
  }

  async logOut() {
    return {
      instanceId: '1234567890',
      status: 'I'
    };
  }
}
